<template>
  <select :value="value" @input="select" class="btn">
    <optgroup
      v-for="option in segments"
      :key="option.name"
      :label="option.name"
    >
      <option v-for="item in option.options" :key="item.id" :value="item.id">
        {{ item.name }}
      </option>
    </optgroup>
  </select>
</template>

<script>
import { segments } from "@/utils/helpers";

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return { segments };
  },
  methods: {
    select(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>

<style></style>
